<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg pt-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div class="display-4 mb-4">Kitsunebi</div>
            <ul>
              <li>系统要求：iOS 9 及以上</li>
              <li>设备要求：iPhone / iPad</li>
              <li>此应用已在国区下架，请使用非国区 Apple ID 下载。</li>
            </ul>
            <div class="display-4 mt-4 mb-4">介绍</div>
            <p>Kitsunebi是专门为V2Ray设计的代理工具，目前在iOS上对V2Ray协议支持最为全面的工具，但稳定性上相比其他两款工具稍差。</p>
            <!-- <div class="display-4 mt-4 mb-4">服务器订阅</div>
            <ul>
              <li>
                手机浏览器打开
                <a href="https://sstz.info" target="_blank">掠影网络用户中心</a> ，点击已订阅套餐（左上三横线-我的服务，或直接在首页点击产品服务），在套餐详情中点击
                <strong>通用订阅链</strong> ，订阅信息会自动复制进剪贴板
              </li>
            </ul>
            <p>
              <img src="/img/client/mobile.png" alt width="300" >
            </p>
            <p>
              <img src="/img/client/mobile-02.png" alt width="300" >
            </p> -->
            <div class="display-4 mt-4 mb-4">订阅信息</div>
            <div v-if="accounts.length">
              <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                <base-button class=" mr-3" size="sm" type="primary" @click="handleCopy(`${subLinks_1}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接1</base-button>
                <base-button size="sm" type="primary" @click="handleCopy(`${subLinks_2}/v1/api/interchangeable/${account.subscription || account._id }`, $event)" >点我复制订阅连接2</base-button>
              </div>
            </div>
            <div v-else>
              <h2 class="display-4" style="font-size: 1.2rem">
                你还没有套餐，
                <router-link :to="{name: 'dashboard-plan'}">立即购买</router-link>
              </h2>
            </div>
            <div class="display-4 mt-4 mb-4">订阅设置</div>
            <ul>
              <li>点击上面按钮，粘贴订阅连接，首次打开Kitsunebi，系统会提示配置VPN，允许后需要使用指纹/Face ID/密码 确认</li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image-51.png" alt >
            </p>
            <p>
              <img src="/img/client/ios/kitsunebi/image-69.png" alt >
            </p>
            <ul>
              <li>
                打开Kitsunebi，选择
                <strong>服务器</strong>选项卡，然后点击
                <strong>右上+号</strong>，在跳出菜单中点击
                <strong>订阅</strong>
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image-48.png" alt >
            </p>
            <ul>
              <li>
                <strong>URL</strong>位置粘贴刚才复制的
                <strong>订阅链</strong>，打开自动更新，然后存储
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image%20%2831%29.png" alt >
            </p>
            <ul>
              <li>回到服务器界面，可以看到斑马线的订阅已添加，点击订阅详情图标</li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image%20%2838%29.png" alt >
            </p>
            <ul>
              <li>点击从URL更新，即可获取套餐对应的所有节点</li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image%20%2851%29.png" alt >
            </p>
            <p>
              <img src="/img/client/ios/kitsunebi/image%20%2846%29.png" alt >
            </p>
            <ul>
              <li>
                选中需要节点后切换到
                <strong>状态</strong>选项卡，打开开关即可开启代理
              </li>
            </ul>
            <p>
              <img src="/img/client/ios/kitsunebi/image%20%287%29.png" alt >
            </p>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style>
.search-noresults img {
  max-width: 100%;
}
</style>
